// extracted by mini-css-extract-plugin
module.exports = {"svgIcon":"_1x27q"};